<section class="w-full bg-white px-6 py-16">
  <div class="w-full mx-auto">
    <!-- Título de la sección -->
    <div class="flex flex-col gap-2 items-center justify-center text-center mb-8">
      <h2 class="text-neutral-gray-900 text-2xl font-poppins font-semibold leading-tight m-0">
        ¿Qué vas hacer hoy?
      </h2>
      <p class="text-neutral-gray-600 font-poppins text-base font-normal leading-4 m-0">
        Herramientas para ti
      </p>
    </div>

    <!-- Grid de herramientas -->
    <div class="grid grid-cols-2 gap-x-4 gap-y-6 max-w-[680px] mx-auto">
      <ui-button-square
        *ngFor="let tool of tools"
        [iconUrl]="tool.iconUrl"
        [title]="getPlainTitle(tool)"
        [comingSoon]="tool.isComingSoon || false"
        [propNew]="tool.isNew || false"
        [state]="getToolState(tool)"
        [size]="'large'"
        [className]="'w-full sm:max-w-[300px] sm:mx-auto'"
        (clicked)="onButtonSquareClick(tool)">
      </ui-button-square>
    </div>
  </div>
</section>

<!-- Modal En Construcción -->
<app-building-modal
  [showConstructionModal]="showToolConstructionModal"
  [description]="'Esta herramienta estará disponible próximamente.'"
  [descriptionSecondary]="'Vuelve pronto para probarla'"
  (closeModal)="closeConstructionModal()"
></app-building-modal>


